// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1ZSwc","log":"ModalInventoryLogs_log__2rtAz","date":"ModalInventoryLogs_date__1gfos","userName":"ModalInventoryLogs_userName__3rfqR"};